<!-- begin:: Page -->
<ng-container *ngIf="userLoaded | async">
  <ng-container *ngIf="selfLayout !== 'blank'; else blankLayout">
    <!-- begin:: Header Mobile -->
    <kt-header-mobile></kt-header-mobile>
    <!-- end:: Header Mobile -->

    <div class="d-flex flex-column flex-root height-100">
      <!-- begin::Body -->
      <div class="d-flex flex-row flex-column-fluid page height-100">
        <!-- begin:: Aside Left -->
        <ng-container *ngIf="asideSelfDisplay && !filterView">
          <kt-aside-left></kt-aside-left>
        </ng-container>
        <!-- end:: Aside Left -->

        <!--begin::Wrapper-->
        <div
          id="kt_wrapper"
          [style.padding-left]="filterView ? '0' : ''"
          class="d-flex flex-column flex-row-fluid wrapper"
        >
          <!-- begin:: Header -->
          <kt-header></kt-header>
          <!-- end:: Header -->

          <!-- begin:: Content -->
          <div
            class="content d-flex flex-column flex-column-fluid height-100"
            id="kt_content"
            [ngClass]="contentClasses"
          >
            <!-- begin:: Content Body -->
            <!--begin::Entry-->
            <div ktContentAnimate class="d-flex flex-column-fluid height-100">
              <!--begin::Container-->
              <div [@.disabled]="suspendAnimations" class="container-fluid" style="padding: 0 12px">
                <router-outlet></router-outlet>
                <!--end::Container-->
              </div>
            </div>
            <!--end::Entry-->
            <!-- end:: Content Body -->
          </div>
          <!-- end:: Content -->
        </div>
        <!--end::Wrapper-->
      </div>
      <!-- end:: Body -->

      <kt-quick-panel></kt-quick-panel>
      <kt-quick-user-panel></kt-quick-user-panel>
      <ng-template ngxPermissionsOnly="accessContextualHistory">
        <kt-timeline-offcanvas></kt-timeline-offcanvas>
      </ng-template>
      <kt-entity-details-offcanvas></kt-entity-details-offcanvas>
      <ng-template ngxPermissionsOnly="accessToChatModule">
        <kt-twixor *ngIf="isAgent"></kt-twixor>
      </ng-template>
      <kt-scroll-top></kt-scroll-top>
      <kt-sticky-toolbar [filteredView]="filterView"></kt-sticky-toolbar>
    </div>
  </ng-container>
  <!-- end:: Page -->

  <ng-template #blankLayout>
    <div [@.disabled]="suspendAnimations" class="d-flex flex-column flex-root">
      <router-outlet></router-outlet>
    </div>
  </ng-template>
</ng-container>
